import { Component } from "react";
import Highcharts from "highcharts/highstock";
import sankey from "highcharts/modules/sankey.js";
import organization from "highcharts/modules/organization.js";
import { connect } from "react-redux";
import SelectOption from "../../../lib/custom/SelectOption/SelectOption";
import "../../../assets/css/network.css";

import api from "../../../lib/api";
import Table from "../../../lib/custom/Table/Table";
import DetailInfomation from "./detailInfomation/DetailInfomation";
import { getFMemberByDate,getFMemberByYesterday,getFMemberLast7Days,getFMemberLast30Days, getFmemberInfo } from "../../../lib/api/affiliate";
import LoadingV2 from "../../../lib/custom/LoadingV2/LoadingV2";
import { withTranslation } from "react-i18next";
import i18next from "i18next";
sankey(Highcharts);
organization(Highcharts);

class Network extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      memberData: [],
      filterBy: "level",
      filteredList: [],
      choosedCommission: {
        id: 1,
        name: `${i18next.t("Rank")} 1`,
        value: "F1",
      },
      nameFind: "",
      listCommission: [
        {
          id: 1,
          name: `${i18next.t("Rank")} 1`,
          value: "F1",
        },
        {
          id: 2,
          name: `${i18next.t("Rank")} 2`,
          value: "F2",
        },
        {
          id: 3,
          name: `${i18next.t("Rank")} 3`,
          value: "F3",
        },
        {
          id: 4,
          name: `${i18next.t("Rank")} 4`,
          value: "F4",
        },
        {
          id: 5,
          name: `${i18next.t("Rank")} 5`,
          value: "F5",
        },
        {
          id: 6,
          name: `${i18next.t("Rank")} 6`,
          value: "F6",
        },
        {
          id: 7,
          name: `${i18next.t("Rank")} 7`,
          value: "F7",
        },
      ],
      timeSearchOption: "yesterday",
      currentPage: 1,
      itemsPerPage: 7,
      totalRecord: 0,
      tableData: [
        { nickname: "Huyendung", level: 7, totalTrade: 679.41, reward: 10.409 },
        { nickname: "Angg98", level: 0, totalTrade: 0, reward: 0 },
        { nickname: "Kenluan", level: 0, totalTrade: 0, reward: 0 },
        { nickname: "Thinhdev", level: 2, totalTrade: 150, reward: 5 },
        { nickname: "JohnDoe", level: 1, totalTrade: 200, reward: 3 },
        { nickname: "JaneSmith", level: 3, totalTrade: 300, reward: 4 },
        { nickname: "AlexTran", level: 4, totalTrade: 100, reward: 1 },
        { nickname: "UserDemo", level: 6, totalTrade: 400, reward: 9 },
        { nickname: "JohnDoe", level: 1, totalTrade: 200, reward: 3 },
        { nickname: "JaneSmith", level: 3, totalTrade: 300, reward: 4 },
        { nickname: "AlexTran", level: 4, totalTrade: 100, reward: 1 },
        { nickname: "UserDemo", level: 6, totalTrade: 400, reward: 9 },
        { nickname: "JohnDoe", level: 1, totalTrade: 200, reward: 3 },
        { nickname: "JaneSmith", level: 3, totalTrade: 300, reward: 4 },
        { nickname: "AlexTran", level: 4, totalTrade: 100, reward: 1 },
        { nickname: "UserDemo", level: 6, totalTrade: 400, reward: 9 },
      ],
      showDetailInfomation: {
        isShowDetail: false,
        userInfo: {},
      },
      daySelected: "yesterday",
    };
  }

  handleCommission = (item) => {
    this.setState({
      choosedCommission: item,
    });
  };
  handleChooseFilterBy = (item) => {
    this.setState({ filterBy: item });
  };
  handleChangeTimeSearchOption = (value) => {
    this.setState({ timeSearchOption: value });
  };
  hanleClickselect = async (value) => {
    this.setState({ daySelected: value });
    // await this.handleLoadData(1);
    this.handleGetFMember(1);
  }
  handleLoadData = (pageNumber = 1) => {
    const search = this.state.filterBy === 'level' ? this.state.choosedCommission.value : this.state.nameFind.toLowerCase();
    this.setState({ isLoading: true });
    const value = this.state.daySelected;
    let fetchFunction;

    if (value === "all") {
      fetchFunction = getFMemberByDate;
    } else if (value === "yesterday") {
      fetchFunction = getFMemberByYesterday;
    } else if (value === "7days") {
      fetchFunction = getFMemberLast7Days;
    } else if (value === "30days") {
      fetchFunction = getFMemberLast30Days;
    }
    
    if (fetchFunction) {
      fetchFunction(this.state.itemsPerPage, pageNumber, search, this.state.filterBy).then((data) => {
        this.setState({ memberData: data.data, isLoading: false, totalRecord: data.total });
      });
    }
  }
  handleChooseUser = (value) => {
    this.setState({ isLoading: true });
    // this.setState({
    //   // truyền member id
    //   showDetailInfomation: { isShowDetail: true, userInfo: value },
    // });
    getFmemberInfo(value.id).then((data) => {
      console.log("data", data);
      this.setState({
        showDetailInfomation: { isShowDetail: true, userInfo: data.data },
        isLoading: false,
      });
    });
  };
  handleCloseDetailInfomation = () => {
    this.setState({
      showDetailInfomation: {
        isShowDetail: false,
        userInfo: {},
      },
    });
  };

  handleGetFMember = async (pageNumber = 1) => {
    this.setState({ isLoading: true });
    await this.handleLoadData(pageNumber);
    this.setState({ isLoading: false });
  };
  handleFindByLevelOrName = () => {
    this.handleLoadData(1);
  }

  // handleFindByLevel() {
  //   this.setState({ isLoading: true });
  //   const findList =
  //     this.state?.memberData.filter((item) => {
  //       return item.title === this.state.choosedCommission.value;
  //     }) || [];
  //   this.setState({ filteredList: findList }, () => {
  //     console.log("filteredList", this.state.filteredList);

  //   });
  //   this.setState({ isLoading: false });
  // }
  // handleFindByName = async () => {
  //   if (this.state.nameFind === "") {
  //     this.setState({ isLoading: true });
  //     await this.handleGetFMember();
  //     this.setState({ isLoading: false });
  //   } else {
  //     this.setState({ isLoading: true });
  //     const findList =
  //       this.state?.memberData.filter((item) => {
  //         return item.username.includes(this.state.nameFind);
  //       }) || [];
  //       this.setState({ filteredList: findList });
  //       this.setState({ isLoading: false });
  //   }
  // };
  componentDidMount() {
    this.handleGetFMember();
  }

  handleChangePage = (pageNumber) => {
    // this.setState({ currentPage: pageNumber });
    this.handleGetFMember(pageNumber);
  }

  render() {
    let { t } = this.props;
    return (
      <div>
        <LoadingV2 isLoading={this.state.isLoading} />
        {!this.state.showDetailInfomation.isShowDetail && (
          <>
            <div className="network-wrapper ">
              <h1>{t("VipMemberManagement")}</h1>
              <div
                className="filter-by flex-wrap d-flex justify-content-start "
                style={{
                  margin: 0,
                }}
              >
                <div className="filter-option">
                  <label htmlFor="">{t("SearchBy")}</label>
                  <div>
                    <button
                      className={this.state.filterBy === "level" ? "active" : ""}
                      onClick={() => {
                        this.handleChooseFilterBy("level");
                      }}
                    >
                      {t("Rank")}
                    </button>
                    <button
                      className={this.state.filterBy === "name" ? "active" : ""}
                      onClick={() => {
                        this.handleChooseFilterBy("name");
                      }}
                    >
                      {t("Nickname")}
                    </button>
                  </div>
                </div>
                <div
                  className="d-lg-block d-none"
                  style={{
                    height: "70px",
                    width: "1px",
                    borderLeft: "1px solid #303539",
                    margin: "0 20px",
                  }}
                ></div>
                {this.state.filterBy === "level" && (
                  <div>
                    <label htmlFor="">
                      {t("ShowReferers")}
                    </label>
                    <div>
                      <SelectOption
                        listCommission={this.state.listCommission}
                        choosedCommission={this.state.choosedCommission}
                        handleCommission={this.handleCommission}
                      />
                      <button
                        className="active"
                        style={{
                          userSelect: "none",
                        }}
                        onClick={() => {
                          this.handleFindByLevelOrName();
                        }}
                      >
                        {t("Search")}
                      </button>
                    </div>
                  </div>
                )}
                {this.state.filterBy === "name" && (
                  <div>
                    <label htmlFor="">{t("ShowReferersByName")}</label>
                    <div
                      className="row d-flex justify-content-start"
                      style={{
                        margin: 0,
                      }}
                    >
                      <input
                        className="col"
                        type="text"
                        placeholder={t("EnterUserName")}
                        style={{
                          backgroundColor: "white",
                          borderRadius: "10px",
                        }}
                        onChange={(e) => {
                          this.setState({ nameFind: e.target.value });
                        }}
                      />
                      <button
                        className="col active"
                        style={{
                          userSelect: "none",
                        }}
                        onClick={() => {
                          this.handleFindByLevelOrName();
                        }}
                      >
                        {t("Search")}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div>
              <Table
                timeSearchOption={this.state.timeSearchOption}
                handleChangeTimeSearchOption={this.handleChangeTimeSearchOption}
                handleChooseUser={this.handleChooseUser}
                hanleClickselect={this.hanleClickselect}
                data={this.state.memberData}
                handleChangePage={this.handleChangePage}
                totalRecord={this.state.totalRecord}
              />
            </div>
          </>
        )}
        {this.state.showDetailInfomation.isShowDetail && (
          <DetailInfomation
            handleCloseDetailInfomation={this.handleCloseDetailInfomation}
            userInfo={this.state.showDetailInfomation.userInfo}
            handleChangeTab={this.props.handleChangeTab}
          />
        )}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    memberReducer: state.memberReducer,
    appReducer: state.appReducer,
  };
}

export default connect(mapStateToProps, null)(withTranslation()(Network));
